import dealer_config from "../data/dealer_config.json";
import axios from 'axios';
import PowerTrip from "../services/api/PowerTrip.js";
import _ from 'lodash';
import Vue from 'vue';
export default {

    carType: "Standard",
    user_settings: Object.assign({}, dealer_config.default_settings),
    default_settings: Object.assign({},dealer_config),
    username: "",
    password: "",
    serviceCode: "",
    carData: [],
    modelData: [],
    powertripAccountBaseURL: "https://thepowertrip.co.nz/",//"https://powertrip.littlemonkey.info/", //
    async init(serviceCode, vuetify) {
        console.log(/* @mangle  */"INIT DEALERS" /* @/mangle */);
        if (serviceCode) {
            this.serviceCode = serviceCode;
        }

        if (localStorage.getItem("credentials")) {
            let split = localStorage.getItem("credentials").split("|@|!|");
            this.username = split[0];
            this.password = split[1];
        }
        if (this.serviceCode !== undefined) {

            let response = await axios.get(this.powertripAccountBaseURL + "referral/service/" + this.serviceCode, {
                auth: {
                    username: this.username,
                    password: this.password
                }
            });
 
            _.merge(this.default_settings, response.data);
            //this.default_settings = { ...this.default_settings, ...response.data };
            this.user_settings = Object.assign({}, this.default_settings.default_settings);
            if (typeof this.default_settings.addressData == "string") {
                try {

                    this.default_settings.addressData = JSON.parse(this.default_settings.addressData);
                } catch(e) {
                    console.log("Invalid JSON");
                }
            }
            this.fixTheme();
            this.updateTheme(vuetify);

            this.carData = await this.loadCars();
            this.modelData = await PowerTrip.getEVModels();

            return this.default_settings;
        } else {
            this.modelData = await PowerTrip.getEVModels();

            return this.default_settings;           
        }


    },
    fixTheme() {
        if (this.default_settings.theme.primary == null) {
            this.default_settings.theme = {
                primary: '#1976D2',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                anchor: '#1976D2'
            };
        }
    },
    save() {
        console.log("Saving");
        var clone = JSON.parse(JSON.stringify(this.default_settings));
        try {
        clone.contactAddress = clone.addressData.Address.Address;
        clone.latitude = clone.addressData.Address.geometry.coordinates[1];
        clone.longitude = clone.addressData.Address.geometry.coordinates[0];
        } catch (e) {
            console.log(e);
        }
        clone.addressData = JSON.stringify(clone.addressData);
        
        axios.post(this.powertripAccountBaseURL + "referral/service/" + this.serviceCode, JSON.stringify(clone), {
            auth: {
                username: this.username,
                password: this.password
            }
        });
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Save Dealer Settings",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
    },
    saveCars(cars) {
                Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Save Dealer Cars",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.post(this.powertripAccountBaseURL + "referral/cars/" + this.serviceCode, JSON.stringify(cars), {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });

    },
    loadCars() {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Load Dealer Cars",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.get(this.powertripAccountBaseURL + "referral/cars/" + this.serviceCode).then(response => {
            return response.data
        });

    },

    loadAllCars() {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Load All Dealer Cars",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.get(this.powertripAccountBaseURL + "referral/aggregatecars/" + this.serviceCode).then(response => {
            return response.data
        });
    },
    getReferrals() {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Get Referrals",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.get(this.powertripAccountBaseURL + "referral/referrals/" + this.serviceCode, {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });

    },
    myCrew() {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Get Crew",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.get(this.powertripAccountBaseURL + "referral/mycrew/" + this.serviceCode, {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    enquiries() {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Get Enquiries",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.get(this.powertripAccountBaseURL + "referral/enquiries/" + this.serviceCode, {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    sendUpdate(title, message, crew, points) {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Send Update",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        const payload = { 'title': title, 'message': message, 'crew': crew, "awardPoints":points}
        return axios.post(this.powertripAccountBaseURL + "referral/broadcastupdate/" + this.serviceCode, JSON.stringify(payload), {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    assignPoints(code, referralPoints, referredPoints) {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Assign Points",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        const payload = { 'contact': true, 'referrerPoints': referralPoints, 'referredPoints': referredPoints }
        return axios.post(this.powertripAccountBaseURL + "referral/referrals/" + code, JSON.stringify(payload), {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
        createReminder(data) {
        return axios.post(this.powertripAccountBaseURL + "referral/submitReminders",JSON.stringify([data]),{
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    async signup(serviceName, email, password, firstname, surname, username) {
        this.username = email;
        this.password = password;
        var result = {};
        const payload = { 'title': serviceName, 'email': email, 'password': password, 'firstname': firstname, 'surname':surname,'username':username }
        try {
            result = await axios.post(this.powertripAccountBaseURL + "referral/servicesignup/", JSON.stringify(payload));
        } catch (e) {
            result.data = {}
            result.data.message = "failed";
        }
        return result.data;
    },
    async checklogin(username, password) {
        this.username = username;
        this.password = password;
        var result = {};
        try {

            result = await axios.get(this.powertripAccountBaseURL + "referral/authcheck/" + this.serviceCode, {
                auth: {
                    username: this.username,
                    password: this.password
                }
            });
        } catch (e) {
            result.data = {}
            result.data.message = "failed";
        }
        if (result.data.message == "signup") {
            Vue.prototype.$user = result.data.member;
            if (result.data.member.trips) {
              Vue.prototype.$trips = JSON.parse(result.data.member.trips);
            }
  
            // Vue.prototype.$auth = data;
            localStorage.setItem("token", result.data.member.token);
            axios.defaults.headers.common["X-Auth-Powertrip"] = result.data.member.token;
            return 'signup';
        }
        if (result.data.message == "redirect") {
            return result.data.service;
        }
        return result.data.message == "success";
    },
    generateVouchers(points) {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Generate Vouchers",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        const payload = {'points': points }
        console.log("Sending request...");
        return axios.post(this.powertripAccountBaseURL + "referral/generateVouchers/"+ this.serviceCode, JSON.stringify(payload), {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    getVouchers() {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Get Vouchers",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        console.log("Sending request...");
        return axios.get(this.powertripAccountBaseURL + "referral/getVouchers/"+ this.serviceCode,  {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    emailVoucher(email, voucherCode) {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Email Voucher",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        const payload = {'code': voucherCode,'email':email }
        console.log("Sending request...");
        return axios.post(this.powertripAccountBaseURL + "referral/emailVoucher/"+ this.serviceCode, JSON.stringify(payload), {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    updateTheme($vuetify) {
        if (this.default_settings.theme && $vuetify.theme) {
            console.log($vuetify.theme);
            console.log(this.default_settings.theme);

            $vuetify.theme.dark = this.default_settings.theme.dark;

            $vuetify.theme.themes.dark.primary = this.default_settings.theme.primary;
            $vuetify.theme.themes.dark.secondary = this.default_settings.theme.secondary;
            $vuetify.theme.themes.dark.accent = this.default_settings.theme.accent;
            $vuetify.theme.themes.dark.anchor = this.default_settings.theme.anchor;

            $vuetify.theme.themes.light.primary = this.default_settings.theme.primary;
            $vuetify.theme.themes.light.secondary = this.default_settings.theme.secondary;
            $vuetify.theme.themes.light.accent = this.default_settings.theme.accent;
            $vuetify.theme.themes.light.anchor = this.default_settings.theme.anchor;
        }

    }
}